import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {ApiConfig} from "../models/api-config.model";

export class IamApiService {
  constructor(private $http: IHttpService, private apiConfig: ApiConfig, private $q: IQService) {
  }

  validateUserPhone(phone) {

    const deferred = this.$q.defer();

    this.validateUserPhoneAndEmail(null, phone)
      .then((data) => {
        deferred.resolve(data.isValidPhone);
      }, () => {
        deferred.reject();
      });

    return deferred.promise;
  }

  validateUserEmail(email) {

    const deferred = this.$q.defer();

    this.validateUserPhoneAndEmail(email, null)
      .then((data) => {
        deferred.resolve(data.isValidEmail);
      }, () => {
        deferred.reject();
      });

    return deferred.promise;

  }

  validateUserPhoneAndEmail(email, phone) {

    const deferred = this.$q.defer<any>();
    const base_url = this.apiConfig.baseUrl;

    this.$http.post(base_url + `/iam/validate`, {
      email: email,
      phoneNumber: phone
    })
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        deferred.reject(err.data);
      });

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.commons')
  .service('IamService', IamApiService);
